/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

export default class Video {
  private json: any
  public readonly videoUrl: string
  public readonly title: string
  public readonly alt: string

  constructor (json: any) {
    this.json = json
    this.videoUrl = (json.video_url.href as string).replace('watch?v=', 'embed/')
    this.title = json.video_url.title
    this.alt = json.video_alt_text
  }

  static of (json: any): Video {
    return new Video(json)
  }

  static empty (): Video {
    return new Video({
      video_alt_text: '',
      video_url: {
        href: '',
        title: ''
      }
    })
  }
}
